module.exports = __webpack_public_path__ + "static/media/20.c7bd24c5.jpg";